var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1463_23692",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    stroke: "#000"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    fill: "#D9D9D9",
    stroke: "#000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1463_23692",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 60,
    height: 60,
    stroke: "#000"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 4H4V64H64V4Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1463_23692)",
    fill: "#fff",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7603 24.0175C45.9801 24.4637 46.2 24.9092 46.2 25.3546V41.8454C46.2 42.2917 45.9801 42.738 45.7603 43.1825L42.24 47.8629C41.5796 48.7546 40.7002 49.2 39.6001 49.2H14.3004C12.5407 49.2 11 47.6402 11 45.8576V21.3432C11 19.5607 12.5407 18 14.3004 18H39.6001C40.7002 18 41.5796 18.4463 42.24 19.338L45.7603 24.0175Z",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1997 25.8H48.6591C48.6591 25.8 49.5773 25.7748 50.3275 24.7165L51.5189 23.1999C52.4713 22.1164 53.9008 21.4668 55.3302 21.4668C56.0454 21.4668 56.7597 21.899 56.7597 22.5495V46.3833C56.7597 47.0337 56.2835 47.4668 55.5683 47.4668C54.1389 47.4668 52.7103 46.8172 51.757 45.7337L50.5656 44.2171C49.9215 43.1286 48.6591 43.1336 48.6591 43.1336H46.1997V25.8Z",
    stroke: "#",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.84 35.3339C26.84 34.2938 26.1357 33.6001 25.0805 33.6001H18.0405C16.9844 33.6001 16.28 34.2938 16.28 35.3339V42.2672C16.28 43.3064 16.9844 44.0001 18.0405 44.0001H25.0805C26.1357 44.0001 26.84 43.3064 26.84 42.2672V35.3339Z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.9873d98ee2844e333f3a3e2aad61f7c4.svg";
export { ForwardRef as ReactComponent };